/**
 * 设备 | 设备配置 | 设备任务 | 设备型号 |  redis-worker | 电池 | 道闸 | 摄像头 | 海康 | 设备白名单 | 车辆
 */
import Net from '../net';

const NAME = '[DeviceApi]';
const Log = (...p) => { console['log'](NAME, ...p); }


/** === Device === **/
/** device/list
 * @param {Object} data
 * @param {*} data.page
 * @param {*} data.user_id
 * @param {*} data.org_id
 * @param {*} data.station_id
 * @param {*} data.uid
 * @param {*} data.suid
 * @param {*} data.gateway_id
 * @param {*} data.is_off
 * @param {*} data.types
 * @param {*} data.sort
 * @param {*} data.pre_status
 * @param {*} data.flag_alipay_shualan
 * @param {*} data.flag_service_fee_support
*/
export async function getDeviceList(data = {}) {
  Log('getDeviceList data:', data)
  try {
    const res = await Net.http('device/list', { data })
    Log('getDeviceList res:', res)
    return res
  } catch (err) {
    Log('getDeviceList err:', err)
    throw err
  }
}

/** device/list-params
 * @param {Object} data
 * @param {*} data.page
 * @param {*} data.operator_id
 * @param {*} data.org_id
 * @param {*} data.station_id
 * @param {*} data.uid
 * @param {*} data.suid
 * @param {*} data.gateway_id
 * @param {*} data.is_off
 * @param {*} data.types
 * @param {*} data.sort
 * @param {*} data.pre_status
 * @param {*} data.flag_alipay_shualan
 * @param {*} data.flag_service_fee_support
*/
export async function getDeviceListByOperator(data = {}) {
  Log('getDeviceListByOperator data:', data)
  try {
    const res = await Net.http('device/list-params', { data })
    Log('getDeviceListByOperator res:', res)
    return res
  } catch (err) {
    Log('getDeviceListByOperator err:', err)
    throw err
  }
}

/** stat-new/device-offline-list
 * @param {Object} data
*/
export async function deviceOffList(data = {}) {
  Log('deviceOffList data:', data)
  try {
    const res = await Net.http('stat-new/device-offline-list', { data })
    Log('deviceOffList res:', res)
    return res
  } catch (err) {
    Log('deviceOffList err:', err)
    throw err
  }
}

/** device/shualan-device-list
 * @param {Object} data
 * @param {*} data.uid
 * @param {*} data.suid
 * @param {*} data.org_id
 * @param {*} data.user_id
 * @param {*} data.station_id
 * @param {*} data.gateway_id
 * @param {*} data.page
 * @param {*} data.types
 * @param {*} data.flag_alipay_shualan
*/
export async function deviceShuaLanlist(data = {}) {
  Log('deviceShuaLanlist data:', data)
  try {
    const res = await Net.http('device/shualan-device-list', { data })
    Log('deviceShuaLanlist res:', res)
    return res
  } catch (err) {
    Log('deviceShuaLanlist err:', err)
    throw err
  }
}

/** device/save
 * @param {Object} data
 * @param {*} data.suid
 * @param {*} data.node_index
 * @param {*} data.station_id
*/
export async function saveDevice(data = {}) {
  Log('saveDevice data:', data)
  try {
    const res = await Net.http('device/save', { data })
    Log('saveDevice res:', res)
    return res
  } catch (err) {
    Log('saveDevice err:', err)
    throw err
  }
}

/** device/detail
 * @param {Object} data
 * @param {*} data.suid
*/
export async function getDeviceDetail(data = {}) {
  Log('getDeviceDetail data:', data)
  try {
    const res = await Net.http('device/detail', { data })
    Log('getDeviceDetail res:', res)
    return res
  } catch (err) {
    Log('getDeviceDetail err:', err)
    throw err
  }
}

/** device/detail-by-suid
 * @param {Object} data
 * @param {*} data.suid
*/
export async function getDeviceDetailBySuid(data = {}) {
  Log('getDeviceDetailBySuid data:', data)
  try {
    const res = await Net.http('device/detail-by-suid', { data })
    Log('getDeviceDetailBySuid res:', res)
    return res
  } catch (err) {
    Log('getDeviceDetailBySuid err:', err)
    throw err
  }
}

/** device/delete
 * @param {Object} data
 * @param {*} data.uid
 * @param {*} data.node_index
 * @param {*} data.station_id
*/
export async function deleteDevice(data = {}) {
  Log('deleteDevice data:', data)
  try {
    const res = await Net.http('device/delete', { data })
    Log('deleteDevice res:', res)
    return res
  } catch (err) {
    Log('deleteDevice err:', err)
    throw err
  }
}

/** device/build-network
 * @param {Object} data
 * @param {*} data.station_id
 * @param {*} data.channel
*/
export async function deviceBuildNetwork(data = {}) {
  Log('deviceBuildNetwork data:', data)
  try {
    const res = await Net.http('device/build-network', { data })
    Log('deviceBuildNetwork res:', res)
    return res
  } catch (err) {
    Log('deviceBuildNetwork err:', err)
    throw err
  }
}

/** device-account/device-service-fee-balance
 * @param {Object} data
 * @param {*} data.device_uid
*/
export async function checkDeviceServiceFee(data = {}) {
  Log('checkDeviceServiceFee data:', data)
  try {
    const res = await Net.http('device-account/device-service-fee-balance', { data })
    Log('checkDeviceServiceFee res:', res)
    return res
  } catch (err) {
    Log('checkDeviceServiceFee err:', err)
    throw err
  }
}

/** device-account/service-fee-unpaid-info
 * @param {Object} data
 * @param {*} data.station_id
 * @param {*} data.org_id
*/
export async function checkDeviceServiceFeeById(data = {}) {
  Log('checkDeviceServiceFeeById data:', data)
  try {
    const res = await Net.http('device-account/service-fee-unpaid-info', { data })
    Log('checkDeviceServiceFeeById res:', res)
    return res
  } catch (err) {
    Log('checkDeviceServiceFeeById err:', err)
    throw err
  }
}

/** device/port-list
 * @param {Object} data
 * @param {*} data.device_id
*/
export async function devicePortList(data = {}) {
  Log('devicePortList data:', data)
  try {
    const res = await Net.http('device/port-list', { data })
    Log('devicePortList res:', res)
    return res
  } catch (err) {
    Log('devicePortList err:', err)
    throw err
  }
}

/** device/create-power-qrcode
 * @param {Object} data
 * @param {*} data.uid
*/
export async function createDevicePowerQrcode(data = {}) {
  Log('createDevicePowerQrcode data:', data)
  try {
    const res = await Net.http('device/create-power-qrcode', { data })
    Log('createDevicePowerQrcode res:', res)
    return res
  } catch (err) {
    Log('createDevicePowerQrcode err:', err)
    throw err
  }
}

/** device/get-iot-state
 * @param {Object} data
 * @param {*} data.suid
*/
export async function deviceIotState(data = {}) {
  Log('deviceIotState data:', data)
  try {
    const res = await Net.http('device/get-iot-state', { data })
    Log('deviceIotState res:', res)
    return res
  } catch (err) {
    Log('deviceIotState err:', err)
    throw err
  }
}

/** device/mark-device
 * @param {Object} data
 * @param {*} data.device_id
 * @param {*} data.port_index
 * @param {*} data.mark
*/
export async function deviceMark(data = {}) {
  Log('deviceMark data:', data)
  try {
    const res = await Net.http('device/mark-device', { data })
    Log('deviceMark res:', res)
    return res
  } catch (err) {
    Log('deviceMark err:', err)
    throw err
  }
}

/** device/get-cabinet-pwd
 * @param {Object} data
 * @param {*} data.suid
*/
export async function getDeviceCabinetPwd(data = {}) {
  Log('getDeviceCabinetPwd data:', data)
  try {
    const res = await Net.http('device/get-cabinet-pwd', { data })
    Log('getDeviceCabinetPwd res:', res)
    return res
  } catch (err) {
    Log('getDeviceCabinetPwd err:', err)
    throw err
  }
}

/** device/set-cabinet-pwd
 * @param {Object} data
 * @param {*} data.uid
 * @param {*} data.pwd
*/
export async function setDeviceCabinetPwd(data = {}) {
  Log('setDeviceCabinetPwd data:', data)
  try {
    const res = await Net.http('device/set-cabinet-pwd', { data })
    Log('setDeviceCabinetPwd res:', res)
    return res
  } catch (err) {
    Log('setDeviceCabinetPwd err:', err)
    throw err
  }
}

/** device/open-test
 * @param {Object} data
*/
export async function openDeviceTest(data = {}) {
  Log('openDeviceTest data:', data)
  try {
    const res = await Net.http('device/open-test', { data })
    Log('openDeviceTest res:', res)
    return res
  } catch (err) {
    Log('openDeviceTest err:', err)
    throw err
  }
}

/** device/close-test
 * @param {Object} data
*/
export async function closeDeviceTest(data = {}) {
  Log('closeDeviceTest data:', data)
  try {
    const res = await Net.http('device/close-test', { data })
    Log('closeDeviceTest res:', res)
    return res
  } catch (err) {
    Log('closeDeviceTest err:', err)
    throw err
  }
}

/** device/test-gate-control
 * @param {Object} data
*/
export async function deviceGateTest(data = {}) {
  Log('deviceGateTest data:', data)
  try {
    const res = await Net.http('device/test-gate-control', { data })
    Log('deviceGateTest res:', res)
    return res
  } catch (err) {
    Log('deviceGateTest err:', err)
    throw err
  }
}

/** device/update-gateway-device-status
 * @param {Object} data
*/
export async function updateDeviceGateway(data = {}) {
  Log('updateDeviceGateway data:', data)
  try {
    const res = await Net.http('device/update-gateway-device-status', { data })
    Log('updateDeviceGateway res:', res)
    return res
  } catch (err) {
    Log('updateDeviceGateway err:', err)
    throw err
  }
}

/** device/set-alipay-shualan
 * @param {Object} data
 * @param {*} data.device_id
 * @param {*} data.flag_alipay_shualan
*/
export async function setDeviceAlipayShualan(data = {}) {
  Log('setDeviceAlipayShualan data:', data)
  try {
    const res = await Net.http('device/set-alipay-shualan', { data })
    Log('setDeviceAlipayShualan res:', res)
    return res
  } catch (err) {
    Log('setDeviceAlipayShualan err:', err)
    throw err
  }
}

/** device/batch-set-alipay-shualan
 * @param {Object} data
 * @param {*} data.device_ids
 * @param {*} data.flag_alipay_shualan
*/
export async function deviceBatchSetAlipayShualan(data = {}) {
  Log('deviceBatchSetAlipayShualan data:', data)
  try {
    const res = await Net.http('device/batch-set-alipay-shualan', { data })
    Log('deviceBatchSetAlipayShualan res:', res)
    return res
  } catch (err) {
    Log('deviceBatchSetAlipayShualan err:', err)
    throw err
  }
}

/** device/alipay-device-qr-code
 * @param {Object} data
 * @param {*} data.url
 * @param {*} data.query_param
 * @param {*} data.describe
*/
export async function deviceAlipayDeviceQrcode(data = {}) {
  Log('deviceAlipayDeviceQrcode data:', data)
  try {
    const res = await Net.http('device/alipay-device-qr-code', { data })
    Log('deviceAlipayDeviceQrcode res:', res)
    return res
  } catch (err) {
    Log('deviceAlipayDeviceQrcode err:', err)
    throw err
  }
}

/** device/get-dc-config
 * @param {Object} data
*/
export async function getDeviceDcConfig(data = {}) {
  Log('getDeviceDcConfig data:', data)
  try {
    const res = await Net.http('device/get-dc-config', { data })
    Log('getDeviceDcConfig res:', res)
    return res
  } catch (err) {
    Log('getDeviceDcConfig err:', err)
    throw err
  }
}

/** device/stat-order-by-device
 * @param {Object} data
 * @param {*} data.suid
 * @param {*} data.degin_time
 * @param {*} data.end_time
*/
export async function deviceStatOrderByDevice(data = {}) {
  Log('deviceStatOrderByDevice data:', data)
  try {
    const res = await Net.http('device/stat-order-by-device', { data })
    Log('deviceStatOrderByDevice res:', res)
    return res
  } catch (err) {
    Log('deviceStatOrderByDevice err:', err)
    throw err
  }
}

/** device/set-coin-count
 * @param {Object} data
 * @param {*} data.suid
 * @param {*} data.coin_count
*/
export async function setDeviceCoinCount(data = {}) {
  Log('setDeviceCoinCount data:', data)
  try {
    const res = await Net.http('device/set-coin-count', { data })
    Log('setDeviceCoinCount res:', res)
    return res
  } catch (err) {
    Log('setDeviceCoinCount err:', err)
    throw err
  }
}

/** export-task/list
 * @param {Object} data
 * @param {*} data.page
 * @param {*} data.type
 * @param {*} data.status
*/
export async function exportDeviceList(data = {}) {
  Log('exportDeviceList data:', data)
  try {
    const res = await Net.http('export-task/list', { data })
    Log('exportDeviceList res:', res)
    return res
  } catch (err) {
    Log('exportDeviceList err:', err)
    throw err
  }
}

/** export-task/create-device-export
 * @param {Object} data
 * @param {*} data.operator_id
 * @param {*} data.org_id
 * @param {*} data.station_id
 * @param {*} data.online_status
 * @param {*} data.types
*/
export async function exportDevice(data = {}) {
  Log('exportDevice data:', data)
  try {
    const res = await Net.http('export-task/create-device-export', { data })
    Log('exportDevice res:', res)
    return res
  } catch (err) {
    Log('exportDevice err:', err)
    throw err
  }
}

/** device/send-device-qrcode-zip
 * @param {Object} data
 * @param {*} data.uid
 * @param {*} data.qrcode_type
*/
export async function sendDeviceDeviceQrcodeZip(data = {}) {
  Log('sendDeviceDeviceQrcodeZip data:', data)
  try {
    const res = await Net.http('device/send-device-qrcode-zip', { data })
    Log('sendDeviceDeviceQrcodeZip res:', res)
    return res
  } catch (err) {
    Log('sendDeviceDeviceQrcodeZip err:', err)
    throw err
  }
}

/** device/set-flag-vin-charge
 * @param {Object} data
 * @param {*} data.id
 * @param {*} data.is_enable
*/
export async function setDeviceFlagVinCharge(data = {}) {
  Log('setDeviceFlagVinCharge data:', data)
  try {
    const res = await Net.http('device/set-flag-vin-charge', { data })
    Log('setDeviceFlagVinCharge res:', res)
    return res
  } catch (err) {
    Log('setDeviceFlagVinCharge err:', err)
    throw err
  }
}


/** === DeviceConfig === **/
/** station/get-node-system-config
 * @param {Object} data
 * @param {*} data.gateway_uid
 * @param {*} data.node_index
*/
export async function getDeviceConfigConfig(data = {}) {
  Log('getDeviceConfigConfig data:', data)
  try {
    const res = await Net.http('station/get-node-system-config', { data })
    Log('getDeviceConfigConfig res:', res)
    return res
  } catch (err) {
    Log('getDeviceConfigConfig err:', err)
    throw err
  }
}

/** station/set-node-system-config
 * @param {Object} data
 * @param {*} data.gateway_uid
 * @param {*} data.node_index
 * @param {*} data.charge_full_timeout
 * @param {*} data.no_load_timeout
 * @param {*} data.charge_full_power_threshold
 * @param {*} data.no_load_power_threshold
 * @param {*} data.max_charge_time
 * @param {*} data.height_temperature_threshold
 * @param {*} data.cabinet_heater_enable 
 * @param {*} data.max_charge_power
 * @param {*} data.charge_single_amount
 * @param {*} data.max_current
*/
export async function setDeviceConfigConfig(data = {}) {
  Log('setDeviceConfigConfig data:', data)
  try {
    const res = await Net.http('station/set-node-system-config', { data })
    Log('setDeviceConfigConfig res:', res)
    return res
  } catch (err) {
    Log('setDeviceConfigConfig err:', err)
    throw err
  }
}

/** station/batch-update-set-node-system-config
 * @param {Object} data
 * @param {*} data.json
 * @param {*} data.charge_full_timeout
 * @param {*} data.no_load_timeout
 * @param {*} data.charge_full_power_threshold
 * @param {*} data.no_load_power_threshold
 * @param {*} data.max_charge_time
 * @param {*} data.height_temperature_threshold
 * @param {*} data.cabinet_heater_enable 
 * @param {*} data.max_current
*/
export async function deviceConfigBatchSetConfig(data = {}) {
  Log('deviceConfigBatchSetConfig data:', data)
  try {
    const res = await Net.http('station/batch-update-set-node-system-config', { data })
    Log('deviceConfigBatchSetConfig res:', res)
    return res
  } catch (err) {
    Log('deviceConfigBatchSetConfig err:', err)
    throw err
  }
}

/** station/get-node-system-config-12
 * @param {Object} data
 * @param {*} data.json
*/
export async function getDeviceConfigMultiholePower(data = {}) {
  Log('getDeviceConfigMultiholePower data:', data)
  try {
    const res = await Net.http('station/get-node-system-config-12', { data })
    Log('getDeviceConfigMultiholePower res:', res)
    return res
  } catch (err) {
    Log('getDeviceConfigMultiholePower err:', err)
    throw err
  }
}

/** station/set-node-system-config
 * @param {Object} data
 * @param {*} data.gateway_uid
 * @param {*} data.node_index
 * @param {*} data.charge_full_timeout
 * @param {*} data.no_load_timeout
 * @param {*} data.charge_full_power_threshold
 * @param {*} data.no_load_power_threshold
 * @param {*} data.max_charge_time
 * @param {*} data.height_temperature_threshold
 * @param {*} data.charge_single_amount
*/
export async function setDeviceConfigMultiholeConfig(data = {}) {
  Log('setDeviceConfigMultiholeConfig data:', data)
  try {
    const res = await Net.http('station/set-node-system-config', { data })
    Log('setDeviceConfigMultiholeConfig res:', res)
    return res
  } catch (err) {
    Log('setDeviceConfigMultiholeConfig err:', err)
    throw err
  }
}

/** station/set-node-system-config-12
 * @param {Object} data
 * @param {*} data.json
*/
export async function setDeviceConfigMultiholePower(data = {}) {
  Log('setDeviceConfigMultiholePower data:', data)
  try {
    const res = await Net.http('station/set-node-system-config-12', { data })
    Log('setDeviceConfigMultiholePower res:', res)
    return res
  } catch (err) {
    Log('setDeviceConfigMultiholePower err:', err)
    throw err
  }
}


/** === DeviceTask === **/
/** device-task/save
 * @param {Object} data
 * @param {*} data.id
 * @param {*} data.operator_id
 * @param {*} data.name
 * @param {*} data.config
 * @param {*} data.type
*/
export async function saveDeviceTask(data = {}) {
  Log('saveDeviceTask data:', data)
  try {
    const res = await Net.http('device-task/save', { data })
    Log('saveDeviceTask res:', res)
    return res
  } catch (err) {
    Log('saveDeviceTask err:', err)
    throw err
  }
}

/** device-task/list
 * @param {Object} data
 * @param {*} data.page
 * @param {*} data.operator_id
 * @param {*} data.name
 * @param {*} data.config_type
*/
export async function getDeviceTaskList(data = {}) {
  Log('getDeviceTaskList data:', data)
  try {
    const res = await Net.http('device-task/list', { data })
    Log('getDeviceTaskList res:', res)
    return res
  } catch (err) {
    Log('getDeviceTaskList err:', err)
    throw err
  }
}

/** device-task/delete
 * @param {Object} data
 * @param {*} data.id
*/
export async function deleteDeviceTask(data = {}) {
  Log('deleteDeviceTask data:', data)
  try {
    const res = await Net.http('device-task/delete', { data })
    Log('deleteDeviceTask res:', res)
    return res
  } catch (err) {
    Log('deleteDeviceTask err:', err)
    throw err
  }
}

/** device-task/detail
 * @param {Object} data
 * @param {*} data.id
*/
export async function getDeviceTaskDetail(data = {}) {
  Log('getDeviceTaskDetail data:', data)
  try {
    const res = await Net.http('device-task/detail', { data })
    Log('getDeviceTaskDetail res:', res)
    return res
  } catch (err) {
    Log('getDeviceTaskDetail err:', err)
    throw err
  }
}

/** device-task/execute
 * @param {Object} data
 * @param {*} data.id
*/
export async function deviceTaskExecute(data = {}) {
  Log('deviceTaskExecute data:', data)
  try {
    const res = await Net.http('device-task/execute', { data })
    Log('deviceTaskExecute res:', res)
    return res
  } catch (err) {
    Log('deviceTaskExecute err:', err)
    throw err
  }
}


/** === DeviceTaskMember === **/
/** device-task-member/list
 * @param {Object} data
 * @param {*} data.page
 * @param {*} data.task_id
 * @param {*} data.device_type
 * @param {*} data.status
*/
export async function getDeviceTaskMemberList(data = {}) {
  Log('getDeviceTaskMemberList data:', data)
  try {
    const res = await Net.http('device-task-member/list', { data })
    Log('getDeviceTaskMemberList res:', res)
    return res
  } catch (err) {
    Log('getDeviceTaskMemberList err:', err)
    throw err
  }
}

/** device-task-member/save
 * @param {Object} data
 * @param {*} data.task_id
 * @param {*} data.device_id
*/
export async function saveDeviceTaskMember(data = {}) {
  Log('saveDeviceTaskMember data:', data)
  try {
    const res = await Net.http('device-task-member/save', { data })
    Log('saveDeviceTaskMember res:', res)
    return res
  } catch (err) {
    Log('saveDeviceTaskMember err:', err)
    throw err
  }
}

/** device-task-member/batch-save
 * @param {Object} data
 * @param {*} data.task_id
 * @param {*} data.device_ids
*/
export async function deviceTaskMemberBatchSave(data = {}) {
  Log('deviceTaskMemberBatchSave data:', data)
  try {
    const res = await Net.http('device-task-member/batch-save', { data })
    Log('deviceTaskMemberBatchSave res:', res)
    return res
  } catch (err) {
    Log('deviceTaskMemberBatchSave err:', err)
    throw err
  }
}

/** device-task-member/save-by-station
 * @param {Object} data
 * @param {*} data.task_id
 * @param {*} data.station_id
*/
export async function saveDeviceTaskMemberByStation(data = {}) {
  Log('saveDeviceTaskMemberByStation data:', data)
  try {
    const res = await Net.http('device-task-member/save-by-station', { data })
    Log('saveDeviceTaskMemberByStation res:', res)
    return res
  } catch (err) {
    Log('saveDeviceTaskMemberByStation err:', err)
    throw err
  }
}

/** device-task-member/batch-save-by-station
 * @param {Object} data
 * @param {*} data.task_id
 * @param {*} data.station_ids
*/
export async function deviceTaskMemberBatchSaveByStation(data = {}) {
  Log('deviceTaskMemberBatchSaveByStation data:', data)
  try {
    const res = await Net.http('device-task-member/batch-save-by-station', { data })
    Log('deviceTaskMemberBatchSaveByStation res:', res)
    return res
  } catch (err) {
    Log('deviceTaskMemberBatchSaveByStation err:', err)
    throw err
  }
}

/** device-task-member/delete
 * @param {Object} data
 * @param {*} data.id
*/
export async function deleteDeviceTaskMember(data = {}) {
  Log('deleteDeviceTaskMember data:', data)
  try {
    const res = await Net.http('device-task-member/delete', { data })
    Log('deleteDeviceTaskMember res:', res)
    return res
  } catch (err) {
    Log('deleteDeviceTaskMember err:', err)
    throw err
  }
}

/** device-task-member/batch-delete
 * @param {Object} data
 * @param {*} data.ids
*/
export async function batchDeleteDeviceTaskMember(data = {}) {
  Log('batchDeleteDeviceTaskMember data:', data)
  try {
    const res = await Net.http('device-task-member/batch-delete', { data })
    Log('batchDeleteDeviceTaskMember res:', res)
    return res
  } catch (err) {
    Log('batchDeleteDeviceTaskMember err:', err)
    throw err
  }
}


/** === DeviceModel === **/
/** device-model/list
 * @param {Object} data
 * @param {*} data.code
 * @param {*} data.type
 * @param {*} data.uid_rule
 * @param {*} data.name
 * @param {*} data.status
 * @param {*} data.page
 * @param {*} data.page_size
*/
export async function getDeviceModelList(data = {}) {
  Log('getDeviceModelList data:', data)
  try {
    const res = await Net.http('device-model/list', { data })
    Log('getDeviceModelList res:', res)
    return res
  } catch (err) {
    Log('getDeviceModelList err:', err)
    throw err
  }
}

/** device-model/save
 * @param {Object} data
 * @param {*} data.id
 * @param {*} data.code
 * @param {*} data.type
 * @param {*} data.name
 * @param {*} data.uid_rule
 * @param {*} data.port_count
 * @param {*} data.config
 * @param {*} data.status
*/
export async function saveDeviceModel(data = {}) {
  Log('saveDeviceModel data:', data)
  try {
    const res = await Net.http('device-model/save', { data })
    Log('saveDeviceModel res:', res)
    return res
  } catch (err) {
    Log('saveDeviceModel err:', err)
    throw err
  }
}

/** device-model/update-status
 * @param {Object} data
 * @param {*} data.id
 * @param {*} data.status
*/
export async function updateDeviceModelStatus(data = {}) {
  Log('updateDeviceModelStatus data:', data)
  try {
    const res = await Net.http('device-model/update-status', { data })
    Log('updateDeviceModelStatus res:', res)
    return res
  } catch (err) {
    Log('updateDeviceModelStatus err:', err)
    throw err
  }
}

/** device-model/batch-update-status
 * @param {Object} data
 * @param {*} data.ids
 * @param {*} data.status
*/
export async function batchUpdateDeviceModelStatus(data = {}) {
  Log('batchUpdateDeviceModelStatus data:', data)
  try {
    const res = await Net.http('device-model/batch-update-status', { data })
    Log('batchUpdateDeviceModelStatus res:', res)
    return res
  } catch (err) {
    Log('batchUpdateDeviceModelStatus err:', err)
    throw err
  }
}


/** === RedisWorker === **/
/** redis-worker/create-task
 * @param {Object} data
 * @param {*} data.function
 * @param {*} data.params
*/
export async function createRedisWorkerTask(data = {}) {
  Log('createRedisWorkerTask data:', data)
  try {
    const res = await Net.http('redis-worker/create-task', { data })
    Log('createRedisWorkerTask res:', res)
    return res
  } catch (err) {
    Log('createRedisWorkerTask err:', err)
    throw err
  }
}

/** redis-worker/find-task
 * @param {Object} data
 * @param {*} data.task_id
*/
export async function findRedisWorkerTask(data = {}) {
  Log('findRedisWorkerTask data:', data)
  try {
    const res = await Net.http('redis-worker/find-task', { data })
    Log('findRedisWorkerTask res:', res)
    return res
  } catch (err) {
    Log('findRedisWorkerTask err:', err)
    throw err
  }
}


/** === Battery === **/
/** battery/create
 * @param {Object} data
 * @param {*} data.pack_id
 * @param {*} data.operator_id
*/
export async function createBattery(data = {}) {
  Log('createBattery data:', data)
  try {
    const res = await Net.http('battery/create', { data })
    Log('createBattery res:', res)
    return res
  } catch (err) {
    Log('createBattery err:', err)
    throw err
  }
}

/** battery/list
 * @param {Object} data
 * @param {*} data.page
 * @param {*} data.operator_id
 * @param {*} data.pack_id
*/
export async function getBatteryList(data = {}) {
  Log('getBatteryList data:', data)
  try {
    const res = await Net.http('battery/list', { data })
    Log('getBatteryList res:', res)
    return res
  } catch (err) {
    Log('getBatteryList err:', err)
    throw err
  }
}

/** battery/detail
 * @param {Object} data
 * @param {*} data.id
*/
export async function getBatteryDetail(data = {}) {
  Log('getBatteryDetail data:', data)
  try {
    const res = await Net.http('battery/detail', { data })
    Log('getBatteryDetail res:', res)
    return res
  } catch (err) {
    Log('getBatteryDetail err:', err)
    throw err
  }
}

/** battery/import
 * @param {Object} data
 * @param {*} data.file
*/
export async function batteryImport(data = {}) {
  Log('batteryImport data:', data)
  try {
    const res = await Net.http('battery/import', { data })
    Log('batteryImport res:', res)
    return res
  } catch (err) {
    Log('batteryImport err:', err)
    throw err
  }
}

/** battery/delete
 * @param {Object} data
 * @param {*} data.id
*/
export async function deleteBattery(data = {}) {
  Log('deleteBattery data:', data)
  try {
    const res = await Net.http('battery/delete', { data })
    Log('deleteBattery res:', res)
    return res
  } catch (err) {
    Log('deleteBattery err:', err)
    throw err
  }
}

/** battery/bind
 * @param {Object} data
 * @param {*} data.pack_ids
 * @param {*} data.operator_id
*/
export async function bindBattery(data = {}) {
  Log('bindBattery data:', data)
  try {
    const res = await Net.http('battery/bind', { data })
    Log('bindBattery res:', res)
    return res
  } catch (err) {
    Log('bindBattery err:', err)
    throw err
  }
}


/** === Gate === **/
/** gate/save
 * @param {Object} data
 * @param {*} data.operator_id
 * @param {*} data.org_id
 * @param {*} data.suid
 * @param {*} data.node_index
 * @param {*} data.remark
*/
export async function saveGate(data = {}) {
  Log('saveGate data:', data)
  try {
    const res = await Net.http('gate/save', { data })
    Log('saveGate res:', res)
    return res
  } catch (err) {
    Log('saveGate err:', err)
    throw err
  }
}

/** gate/list
 * @param {Object} data
 * @param {*} data.page
 * @param {*} data.operator_id
 * @param {*} data.org_id
 * @param {*} data.uid
 * @param {*} data.suid
 * @param {*} data.type
*/
export async function getGateList(data = {}) {
  Log('getGateList data:', data)
  try {
    const res = await Net.http('gate/list', { data })
    Log('getGateList res:', res)
    return res
  } catch (err) {
    Log('getGateList err:', err)
    throw err
  }
}

/** gate/detail
 * @param {Object} data
 * @param {*} data.id
*/
export async function getGateDetail(data = {}) {
  Log('getGateDetail data:', data)
  try {
    const res = await Net.http('gate/detail', { data })
    Log('getGateDetail res:', res)
    return res
  } catch (err) {
    Log('getGateDetail err:', err)
    throw err
  }
}

/** gate/detail-by-suid
 * @param {Object} data
 * @param {*} data.suid
*/
export async function getGateDetailBySuid(data = {}) {
  Log('getGateDetailBySuid data:', data)
  try {
    const res = await Net.http('gate/detail-by-suid', { data })
    Log('getGateDetailBySuid res:', res)
    return res
  } catch (err) {
    Log('getGateDetailBySuid err:', err)
    throw err
  }
}

/** gate/delete
 * @param {Object} data
 * @param {*} data.id
*/
export async function deleteGate(data = {}) {
  Log('deleteGate data:', data)
  try {
    const res = await Net.http('gate/delete', { data })
    Log('deleteGate res:', res)
    return res
  } catch (err) {
    Log('deleteGate err:', err)
    throw err
  }
}

/** gate/gate-remark
 * @param {Object} data
 * @param {*} data.id
 * @param {*} data.remark
*/
export async function gateRemark(data = {}) {
  Log('gateRemark data:', data)
  try {
    const res = await Net.http('gate/gate-remark', { data })
    Log('gateRemark res:', res)
    return res
  } catch (err) {
    Log('gateRemark err:', err)
    throw err
  }
}

/** gate/test-gate-control
 * @param {Object} data
 * @param {*} data.suid
 * @param {*} data.port_index
 * @param {*} data.gate_state
*/
export async function gateAction(data = {}) {
  Log('gateAction data:', data)
  try {
    const res = await Net.http('gate/test-gate-control', { data })
    Log('gateAction res:', res)
    return res
  } catch (err) {
    Log('gateAction err:', err)
    throw err
  }
}

/** gate/action-log
 * @param {Object} data
 * @param {*} data.page
 * @param {*} data.type
 * @param {*} data.node_index
 * @param {*} data.status
 * @param {*} data.phone
*/
export async function gateActionList(data = {}) {
  Log('gateActionList data:', data)
  try {
    const res = await Net.http('gate/action-log', { data })
    Log('gateActionList res:', res)
    return res
  } catch (err) {
    Log('gateActionList err:', err)
    throw err
  }
}


/** === Camera === **/
/** camera/list
 * @param {Object} data
 * @param {*} data.page
 * @param {*} data.operator_id
 * @param {*} data.org_id
 * @param {*} data.station_id
 * @param {*} data.camera_index_code
*/
export async function getCameraList(data = {}) {
  Log('getCameraList data:', data)
  try {
    const res = await Net.http('camera/list', { data })
    Log('getCameraList res:', res)
    return res
  } catch (err) {
    Log('getCameraList err:', err)
    throw err
  }
}

/** camera/batch-save
 * @param {Object} data
 * @param {*} data.operator_id
 * @param {*} data.org_id
 * @param {*} data.station_id
 * @param {*} data.cameras
*/
export async function cameraImport(data = {}) {
  Log('cameraImport data:', data)
  try {
    const res = await Net.http('camera/batch-save', { data })
    Log('cameraImport res:', res)
    return res
  } catch (err) {
    Log('cameraImport err:', err)
    throw err
  }
}

/** camera/detail
 * @param {Object} data
 * @param {*} data.id
*/
export async function getCameraDetail(data = {}) {
  Log('getCameraDetail data:', data)
  try {
    const res = await Net.http('camera/detail', { data })
    Log('getCameraDetail res:', res)
    return res
  } catch (err) {
    Log('getCameraDetail err:', err)
    throw err
  }
}

/** camera/batch-delete
 * @param {Object} data
 * @param {*} data.ids
*/
export async function deleteCamera(data = {}) {
  Log('deleteCamera data:', data)
  try {
    const res = await Net.http('camera/batch-delete', { data })
    Log('deleteCamera res:', res)
    return res
  } catch (err) {
    Log('deleteCamera err:', err)
    throw err
  }
}

/** hik-camera/camera
 * @param {Object} data
 * @param {*} data.camera_index_code
*/
export async function getCameraUrls(data = {}) {
  Log('getCameraUrls data:', data)
  try {
    const res = await Net.http('hik-camera/camera', { data })
    Log('getCameraUrls res:', res)
    return res
  } catch (err) {
    Log('getCameraUrls err:', err)
    throw err
  }
}


/** === HikConfig === **/
/** hik-config/save
 * @param {Object} data
 * @param {*} data.id
 * @param {*} data.operator_id
 * @param {*} data.host
 * @param {*} data.app_key
 * @param {*} data.app_secret
*/
export async function saveHikConfig(data = {}) {
  Log('saveHikConfig data:', data)
  try {
    const res = await Net.http('hik-config/save', { data })
    Log('saveHikConfig res:', res)
    return res
  } catch (err) {
    Log('saveHikConfig err:', err)
    throw err
  }
}

/** hik-config/list
 * @param {Object} data
 * @param {*} data.page
 * @param {*} data.page_size
 * @param {*} data.operator_id
*/
export async function getHikConfigList(data = {}) {
  Log('getHikConfigList data:', data)
  try {
    const res = await Net.http('hik-config/list', { data })
    Log('getHikConfigList res:', res)
    return res
  } catch (err) {
    Log('getHikConfigList err:', err)
    throw err
  }
}

/** hik-config/delete
 * @param {Object} data
 * @param {*} data.id
*/
export async function deleteHikConfig(data = {}) {
  Log('deleteHikConfig data:', data)
  try {
    const res = await Net.http('hik-config/delete', { data })
    Log('deleteHikConfig res:', res)
    return res
  } catch (err) {
    Log('deleteHikConfig err:', err)
    throw err
  }
}

/** hik-camera/camera-list
 * @param {Object} data
 * @param {*} data.page
 * @param {*} data.page_size
 * @param {*} data.hik_config_id
*/
export async function hikConfigDeviceList(data = {}) {
  Log('hikConfigDeviceList data:', data)
  try {
    const res = await Net.http('hik-camera/camera-list', { data })
    Log('hikConfigDeviceList res:', res)
    return res
  } catch (err) {
    Log('hikConfigDeviceList err:', err)
    throw err
  }
}


/** === DeviceWhite === **/
/** white-panel/save-white-panel-device
 * @param {Object} data
 * @param {*} data.device_uid
 * @param {*} data.port_index
 * @param {*} data.user_id
 * @param {*} data.flag_free
*/
export async function addDeviceWhiteUser(data = {}) {
  Log('addDeviceWhiteUser data:', data)
  try {
    const res = await Net.http('white-panel/save-white-panel-device', { data })
    Log('addDeviceWhiteUser res:', res)
    return res
  } catch (err) {
    Log('addDeviceWhiteUser err:', err)
    throw err
  }
}

/** white-panel/save-white-panel-card
 * @param {Object} data
 * @param {*} data.device_uid
 * @param {*} data.port_index
 * @param {*} data.card_no
 * @param {*} data.flag_free
*/
export async function addDeviceWhiteCard(data = {}) {
  Log('addDeviceWhiteCard data:', data)
  try {
    const res = await Net.http('white-panel/save-white-panel-card', { data })
    Log('addDeviceWhiteCard res:', res)
    return res
  } catch (err) {
    Log('addDeviceWhiteCard err:', err)
    throw err
  }
}

/** white-panel/remove-device-white-panel
 * @param {Object} data
 * @param {*} data.device_uid
 * @param {*} data.port_index
 * @param {*} data.user_id
*/
export async function deviceWhiteRemoveUser(data = {}) {
  Log('deviceWhiteRemoveUser data:', data)
  try {
    const res = await Net.http('white-panel/remove-device-white-panel', { data })
    Log('deviceWhiteRemoveUser res:', res)
    return res
  } catch (err) {
    Log('deviceWhiteRemoveUser err:', err)
    throw err
  }
}

/** white-panel/remove-device-white-panel
 * @param {Object} data
 * @param {*} data.device_uid
 * @param {*} data.port_index
 * @param {*} data.card_no
*/
export async function deviceWhiteRemoveCard(data = {}) {
  Log('deviceWhiteRemoveCard data:', data)
  try {
    const res = await Net.http('white-panel/remove-device-white-panel', { data })
    Log('deviceWhiteRemoveCard res:', res)
    return res
  } catch (err) {
    Log('deviceWhiteRemoveCard err:', err)
    throw err
  }
}

/** white-panel/white-panel-device
 * @param {Object} data
 * @param {*} data.type
 * @param {*} data.device_uid
 * @param {*} data.port_index
*/
export async function getDeviceWhiteDetail(data = {}) {
  Log('getDeviceWhiteDetail data:', data)
  try {
    const res = await Net.http('white-panel/white-panel-device', { data })
    Log('getDeviceWhiteDetail res:', res)
    return res
  } catch (err) {
    Log('getDeviceWhiteDetail err:', err)
    throw err
  }
}

/** white-panel/set-device-white-panel
 * @param {Object} data
 * @param {*} data.type
 * @param {*} data.device_uid
 * @param {*} data.port_index
 * @param {*} data.flag_free
*/
export async function setDeviceWhiteFree(data = {}) {
  Log('setDeviceWhiteFree data:', data)
  try {
    const res = await Net.http('white-panel/set-device-white-panel', { data })
    Log('setDeviceWhiteFree res:', res)
    return res
  } catch (err) {
    Log('setDeviceWhiteFree err:', err)
    throw err
  }
}


/** === Car === **/
/** car/list
 * @param {Object} data
 * @param {*} data.page
 * @param {*} data.license_plate_number
 * @param {*} data.vin
 * @param {*} data.phone
*/
export async function getCarList(data = {}) {
  Log('getCarList data:', data)
  try {
    const res = await Net.http('car/list', { data })
    Log('getCarList res:', res)
    return res
  } catch (err) {
    Log('getCarList err:', err)
    throw err
  }
}
